import dayjs from 'dayjs'

export function formatStartDate(date: Date): string {
  return dayjs(date).format('YYYY-MM-DD') + 'T00:00:00Z'
}

export function formatEndDate(date: Date): string {
  return dayjs(date).format('YYYY-MM-DD') + 'T23:59:59Z'
}
